module.exports = __webpack_public_path__ + "img/102.97dc8a08.png";